export default __webpack_public_path__ + "static/media/mobileTop.437723c6.png";